var map = {
	"./ADA.svg": 925,
	"./BCH.svg": 926,
	"./BNB.svg": 927,
	"./BTC.svg": 928,
	"./CHZ.svg": 929,
	"./DASH.svg": 930,
	"./DOGE.svg": 931,
	"./DOT.svg": 932,
	"./ETC.svg": 933,
	"./ETH.svg": 934,
	"./EUR.svg": 935,
	"./GBP.svg": 936,
	"./LINK.svg": 937,
	"./LTC.svg": 938,
	"./MATIC.svg": 939,
	"./MKR.svg": 940,
	"./SHIB.svg": 941,
	"./SOL.svg": 942,
	"./TRX.svg": 943,
	"./UNI.svg": 944,
	"./USD.svg": 945,
	"./USDT.svg": 946,
	"./XLM.svg": 947,
	"./XMR.svg": 948,
	"./XRP.svg": 949,
	"./documents.svg": 950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 924;